<template>
  <div @click="handleProductClick">
    <div class="single-products">
      <div class="products-image">
        <img
          v-if="
            product.imgURLS &&
              Array.isArray(product.imgURLS) &&
              product.imgURLS[0]
          "
          :src="product.imgURLS[0].url"
          :alt="product.name"
          style="height: 150px;"
        />
        <img
          v-else
          src="@/assets/resourceBlocks/defaultProduct.jpg"
          :alt="product.name"
          style="height: 150px;"
        />
        <!-- <ul>
            <li><a href="#" data-toggle="modal" data-target="#productsModalCenter"><feather type="search"></feather></a></li>
            <li><a href="#"><feather type="heart"></feather></a></li>
            <li><a href="#"><feather type="link"></feather></a></li>
        </ul> -->
      </div>

      <div class="products-content">
        <h3 @click="handleProductClick">
          {{ product.name }}
        </h3>
        <span>${{ product.price }}</span>
        <ul v-if="false">
          <li><i class="flaticon-star-1"></i></li>
          <li><i class="flaticon-star-1"></i></li>
          <li><i class="flaticon-star-1"></i></li>
          <li><i class="flaticon-star-1"></i></li>
          <li><i class="flaticon-star-1"></i></li>
        </ul>
        <b-link class="add-to-cart-btn" @click.stop="handleAddToCart()">
          Add to Cart
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      v2: false
    };
  },
  methods: {
    handleProductClick() {
      this.$emit("product-selected", this.product);
    },
    handleAddToCart() {
      this.$emit("add-to-cart", this.product);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/style.scss";
.single-products {
  text-align: center;
  position: relative;
  margin-bottom: 30px;

  .products-content {
    margin-top: 20px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }
    ul {
      padding: 0;
      margin: 10px 0 12px;
      list-style-type: none;

      li {
        display: inline-block;
        color: #eac11d;

        i {
          &::before {
            font-size: 15px;
          }
        }
      }
    }
    .add-to-cart-btn {
      display: block;
      width: 100%;
      color: $black-color;
      border: 1px solid $black-color;
      padding: 10px 15px;
      text-transform: uppercase;
      font-weight: 500;
    }
  }
  .sale-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #ff2d2d;
    color: #fff;
    width: 55px;
    height: 55px;
    line-height: 55px;
    border-radius: 50%;
    z-index: 2;
  }
  .products-image {
    overflow: hidden;
    position: relative;

    img {
      transition: all 1.5s ease-out;
      /*width: 100%;*/
    }
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: gray;
      content: "";
      transition: $transition;
      z-index: 1;
      opacity: 0;
      visibility: hidden;
    }
    ul {
      padding: 0;
      z-index: 2;
      list-style-type: none;
      margin: 0;
      position: absolute;
      left: 0;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      opacity: 0;
      visibility: hidden;
      transition: $transition;

      li {
        display: inline-block;

        a {
          display: block;
          background: $white-color;
          width: 35px;
          height: 35px;
          line-height: 35px;

          svg {
            width: 20px;
          }
          &:hover,
          &:focus {
            background-color: $light-green-color;
            color: $white-color;
          }
          &:nth-child(1) {
            margin-left: -15px;
          }
          &:nth-child(3) {
            margin-right: -15px;
          }
        }
      }
    }
  }
  &:hover,
  &:focus {
    .products-content {
      .add-to-cart-btn {
        background-color: $black-color;
        color: $white-color;
      }
    }
    .products-image {
      img {
        transform: scale(1.1);
      }
      &::before {
        opacity: 0.4;
        visibility: visible;
      }
      ul {
        opacity: 1;
        visibility: visible;

        li {
          a {
            &:nth-child(1) {
              margin-left: 0;
            }
            &:nth-child(3) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
